import { useGetAdUnitsSearchQuery } from '@/entities/sites/api/sitesApi';
import optionsToIds from '@/entities/sites/ui/site-select/lib/optionsToIds';
import { Select } from '@/shared/ui/select';

export interface ISiteSelect {
  value?: number[];
  sitesSelected?: number[];
  onChange: (value: number[]) => void;
  className?: string;
  disabled?: boolean;
}

export default function AdUnitsSelect({
  value = [],
  sitesSelected,
  onChange,
  className = '',
  disabled,
}: ISiteSelect) {
  const getAdUnitsSearchQuery = useGetAdUnitsSearchQuery();
  const options =
    getAdUnitsSearchQuery?.data
      ?.filter((adUnit) =>
        !sitesSelected ? true : sitesSelected.includes(adUnit.site_id)
      )
      ?.map((adUnit) => ({
        value: adUnit.id,
        label: adUnit.name,
      })) || [];
  const current = options.filter((option) => value.includes(option.value));

  return (
    <div className={`min-w-[180px] ${className}`}>
      <Select
        type="multi"
        withSearch
        current={current}
        multiplyLabel="Ad Units"
        onChange={(value) => {
          onChange(optionsToIds(value));
        }}
        options={options}
        disabled={disabled}
      />
    </div>
  );
}
